module.exports = __webpack_public_path__ + "img/Duke_Volunteer_111.495b5dee.png";